import React from 'react';
import { AudioApi } from '@jenmusic/jen-services';
import { useRequest } from 'ahooks';

interface DemoPageProps {}

const DemoPage: React.FC<DemoPageProps> = () => {
  useRequest(async () => {
    const result = await new AudioApi().audioControllerV2GetAllTracksV2({
      page: 1,
      pageSize: 10,
      sortOrder: 'desc',
      name: '',
      folderId: 0,
      id: '',
      queryType: 'all',
      stylefilter: '',
    });
    return result;
  });
  return <div>demo</div>;
};

export default DemoPage;
